import {
  widgetPlacementItem,
  type PlacementItem,
} from "../../../../hooks/placementItems";
import { WIDGET_PRESETS } from "../../../../nodes/widgets";
import { PlateGrid, Tray, TrayDeck, TraySection } from "../CanvasTrayContent";
import { WidgetPreview, startWidgetDrag } from "./widgetPlates";

/**
 * Blocks — the live widgets the product places (Timer · Vote), on the
 * template plate so Blocks and the stickers read as one kind of picker
 * (DECISIONS D10). A plate arms the block: it attaches to the cursor and a
 * pane click places it (ROUND2 §3), so the armed plate reports pressed.
 * Plates also drag onto the board.
 */
export const BLOCK_PRESETS = WIDGET_PRESETS.filter((p) => !p.family);

export function BlocksTray({
  value = null,
  onSelect,
}: {
  /** The armed item's id, or null. */
  value?: string | null;
  onSelect: (item: PlacementItem) => void;
}) {
  const items = BLOCK_PRESETS.map((preset) => ({
    key: preset.id,
    name: preset.label,
    title: preset.meaning ? `${preset.label}: ${preset.meaning}` : undefined,
    wire: <WidgetPreview preset={preset} width={90} height={60} />,
  }));
  return (
    <Tray>
      <TrayDeck>
        <TraySection ariaLabel="Blocks" bare>
          <PlateGrid
            items={items}
            value={value}
            onChange={(k) => {
              const preset = BLOCK_PRESETS.find((p) => p.id === k);
              if (preset) onSelect(widgetPlacementItem(preset));
            }}
            onDragStart={(it, e) => {
              const preset = BLOCK_PRESETS.find((p) => p.id === it.key);
              if (preset) startWidgetDrag(preset, e);
            }}
          />
        </TraySection>
      </TrayDeck>
    </Tray>
  );
}
